export default __webpack_public_path__ + "static/7-b4616c6ef38fd077cd28a90b2ddd8bc8.png";